import { gql } from "@apollo/client";

const WebResult = gql`
  fragment WebResult on WebResults {
    total
    listings {
      id
      rnpl_monthly_price
      sov_campaign_id
      boosted
      ac
      age
      apts
      area
      deed_area
      backyard
      basement
      beds
      car_entrance
      category
      city_id
      create_time
      biddable
      published_at
      direction_id
      district_id
      province_id
      driver
      duplex
      extra_unit
      family
      family_section
      fb
      fl
      furnished
      has_img
      imgs
      imgs_desc
      ketchen
      last_update
      refresh
      lift
      livings
      location {
        lat
        lng
      }
      maid
      men_place
      meter_price
      playground
      pool
      premium
      price
      price_2_payments
      price_4_payments
      price_12_payments
      range_price
      rent_period
      rooms
      stairs
      stores
      status
      street_direction
      street_width
      tent
      trees
      type
      user_id
      user {
        phone
        name
        img
        type
        paid
        fee
        review
        iam_verified
        rega_id
        bml_license_number
        bml_url
        company_name
        company_logo
      }
      employee {
        phone
        name
        img
      }
      user_type
      vb
      wc
      wells
      women_place
      has_video
      videos {
        video
        thumbnail
        orientation
      }
      verified
      special
      employee_user_id
      mgr_user_id
      unique_listing
      advertiser_type
      appraisal_id
      appraisal
      virtual_tour_link
      project_id
      approved
      native {
        logo
        title
        image
        description
        external_url
      }
      gh_id
      private_listing
      blur
      location_circle_radius
      width
      length
      water_availability
      electrical_availability
      drainage_availability
      private_roof
      apartment_in_villa
      two_entrances
      special_entrance
      daily_rentable
      has_extended_details
      extended_details {
        minimum_booking_days
        ad_license_url
      }
      hide_contact_details
      ad_license_number
      deed_number
      rega_licensed
      published
      comments_enabled
      content
      address
      district
      direction
      city
      title
      path
      uri
      range_price
      original_range_price
      plan_no
      parcel_no
      precise_location_request_status
      precise_location_request_approved_at
      is_auction
      document_pdf
      rega_total_price
      rega_meter_price
    }
  }
`;

export const FIND_LISTINGS = gql`
  ${WebResult}
  query findListings(
    $size: Int
    $from: Int
    $sort: SortInput
    $where: WhereInput
    $polygon: [LocationInput!]
    $daily_renting_filter: DailyRentingFilter
  ) {
    Web {
      find(
        size: $size
        from: $from
        sort: $sort
        where: $where
        polygon: $polygon
        daily_renting_filter: $daily_renting_filter
      ) {
        ...WebResult
      }
    }
  }
`;

export const FIND_LISTINGS_WITH_SOV = gql`
  ${WebResult}
  query findListings(
    $size: Int
    $from: Int
    $sort: SortInput
    $where: WhereInput
    $polygon: [LocationInput!]
    $daily_renting_filter: DailyRentingFilter
    $sov: SovListingsFilter
  ) {
    Web {
      find(
        size: $size
        from: $from
        sort: $sort
        where: $where
        polygon: $polygon
        daily_renting_filter: $daily_renting_filter
      ) {
        ...WebResult
      }
      sov: find(
        from: $from
        sort: $sort
        where: $where
        polygon: $polygon
        daily_renting_filter: $daily_renting_filter
        size: 6
        sov_listings: $sov
      ) {
        ...WebResult
      }
    }
  }
`;
export const GET_LISTING_VIEWS = gql`
  query getViews($id: Int!) {
    Listing {
      views(id: $id)
    }
  }
`;

export const GET_SPECIAL_LISTINGS = gql`
  query GetSpecialListing(
    $category: Int!
    $district_id: Int
    $city_id: Int
    $size: Int
  ) {
    Web {
      special(
        category: $category
        city_id: $city_id
        district_id: $district_id
        size: $size
      ) {
        district {
          ...WebResult
        }
      }
    }
  }
  ${WebResult}
`;
